import Div from "@jumbo/shared/Div";
import { SelectAll } from '@mui/icons-material';
import { Button, List, ListItem } from "@mui/material";
import React from 'react';
import { useDropzone } from "react-dropzone";

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box',
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%',
};

const DzPreviews = ({
    uploadSize = "single",
    onChange,
    value,
    disabled,
    size = "large"
}) => {
    const [files, setFiles] = React.useState([]);

    const { getRootProps, getInputProps, open } = useDropzone({
        multiple: uploadSize === "multi",
        onDrop: acceptedFiles => {
            if (!acceptedFiles || acceptedFiles.length === 0) return;

            onChange(uploadSize === "single"
                ? Object.assign(acceptedFiles[0], {
                    preview: URL.createObjectURL(acceptedFiles[0]),
                })
                : acceptedFiles
            );

            setFiles(
                uploadSize === "single"
                    ? [Object.assign(acceptedFiles[0], {
                        preview: URL.createObjectURL(acceptedFiles[0]),
                    })]
                    : acceptedFiles.map(file =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        }),
                    ),
            );
        },
        value
    });

    const thumbs = files.map(file => (
        file.type && file.type.startsWith('image/') ? (
            <div style={thumb} key={file.name}>
                <div style={thumbInner}>
                    <img src={file.preview} style={img} alt={file.name} />
                </div>
            </div>
        ) : (
            <List disablePadding sx={{ display: 'flex' }} key={file.path || file.name}>
                <ListItem selected sx={{ width: 'auto', mr: 1 }}>
                    {file.path || file.name} - {file.size} bytes
                </ListItem>
            </List>
        )
    ));

    React.useEffect(() => {
        return () => {
            files.forEach(file => URL.revokeObjectURL(file.preview));
        };
    }, [files]);

    return (
        <Div sx={{ flex: 1 }}>
            <div {...getRootProps({ className: 'dropzone' })}>
                <input multiple={uploadSize === "multi"} {...getInputProps()} />
            </div>
            <Button
                disabled={disabled}
                startIcon={<SelectAll />}
                size="medium"
                variant="outlined"
                onClick={open}
                sx={{ fontSize: '0.8rem' }}
            >
                Seç
            </Button>
            {value && <aside style={thumbsContainer}>{thumbs}</aside>}
        </Div>
    );
};

export default DzPreviews;
